<script setup>
import PayInvoiceButton from '@/Components/Models/Invoice/PayInvoiceButton.vue';
import DownloadPDF from '@/Components/Models/Invoice/DownloadPDF.vue';
import OpenInXero from '@/Components/Models/Invoice/OpenInXero.vue';

import { useAuthStore } from '@/Stores/auth'
const auth = useAuthStore()

const props = defineProps({
	params: {
		type: Object,
		required: true,
	},
})
</script>

<template>
	<div class="flex row">
		
		<PayInvoiceButton
			v-if="auth.can('make_payments') && !auth.isAdmin && params.data.Status == 'AUTHORISED' "
			class="mr-1"
			:invoice="params.data"
			cardable_type="organisation"
			:cardable_id="params.context.organisation.id"
		/>
		<DownloadPDF
			:invoice-id="params.data.InvoiceID"
		/>
		<OpenInXero
			:invoice-id="params.data.InvoiceID"
			v-if="auth.isAdmin"
			class="ml-1"
		/>
	</div>
</template>